import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { Field, Input, Btn, Card, PageHead, Spinner, useData } from "./ui";

const FIELDS = [["name", "Firmanavn"], ["orgnr", "Organisasjonsnummer"], ["phone", "Telefon"], ["email", "E-post"], ["website", "Nettside"],
  ["address", "Firmaadresse"], ["bank_account", "Bankkontonummer"]];

export const Settings = () => {
  const [data] = useData("/admin/settings/company");
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data && !Array.isArray(data)) setC(data); }, [data]);
  const save = async () => {
    setBusy(true);
    try { const r = await api.put("/admin/settings/company", c); setC(r.data); toast.success("Firmaopplysninger lagret"); }
    catch (e) { toast.error(errorText(e)); } finally { setBusy(false); }
  };
  if (!c) return <Spinner />;
  return (
    <div data-testid="settings-page">
      <PageHead title="Innstillinger" sub="Firmaopplysninger brukes i kontrakter, kvitteringer og protokoller" />
      <Card className="grid gap-3 md:grid-cols-2">
        {FIELDS.map(([k, l]) => (
          <Field key={k} label={l}>
            <Input value={c[k] ?? ""} onChange={(e) => setC({ ...c, [k]: e.target.value })} placeholder={["address", "bank_account"].includes(k) ? "Må fylles inn" : ""} data-testid={`company-${k}-input`} />
          </Field>
        ))}
        <div className="md:col-span-2"><Btn variant="red" onClick={save} disabled={busy} data-testid="company-save">Lagre</Btn></div>
      </Card>
      <ResetNumbering />
    </div>
  );
};

const ResetNumbering = () => {
  const [ask, setAsk] = useState(false);
  const [busy, setBusy] = useState(false);
  const reset = async () => {
    setBusy(true);
    try { await api.post("/admin/documents/reset-numbering"); toast.success("Nummereringen starter på nytt (KK-0001, KV-0001, OP-0001)"); setAsk(false); }
    catch (e) { toast.error(errorText(e)); } finally { setBusy(false); }
  };
  return (
    <Card className="mt-6" data-testid="reset-numbering">
      <h3 className="font-display text-xl font-bold uppercase">Dokumentnummerering</h3>
      <p className="mb-3 mt-1 text-xs text-zinc-400">Start KK-, KV- og OP-numrene på nytt fra 0001. Kun mulig når ingen aktive salgsdokumenter finnes (f.eks. etter at testbiler er slettet).</p>
      {!ask ? <Btn onClick={() => setAsk(true)} data-testid="reset-numbering-btn">Start nummerering på nytt</Btn> : (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-sm text-zinc-200">Neste kontrakt blir KK-0001. Fortsette?</span>
          <Btn variant="red" onClick={reset} disabled={busy} data-testid="reset-numbering-yes">Ja, start på nytt</Btn>
          <Btn onClick={() => setAsk(false)}>Avbryt</Btn>
        </div>
      )}
    </Card>
  );
};
